export var rowClassSymbol = Symbol();
export var EditReadPosition;
(function (EditReadPosition) {
    EditReadPosition["Left"] = "left";
    EditReadPosition["Right"] = "right";
})(EditReadPosition || (EditReadPosition = {}));
export var ExtraControlButtonPosition;
(function (ExtraControlButtonPosition) {
    ExtraControlButtonPosition["TopLeft"] = "top-left";
    ExtraControlButtonPosition["TopRight"] = "top-right";
    ExtraControlButtonPosition["BottomLeft"] = "bottom-left";
    ExtraControlButtonPosition["BottomRight"] = "bottom-right";
})(ExtraControlButtonPosition || (ExtraControlButtonPosition = {}));
